export const request = async (input: RequestInfo | URL, init?: RequestInit) => {
  const req = await fetch(input, init);
  if (!req.ok) {
    const body = await req.text();
    throw new Error(`Request failed: ${body}`);
  }
  const body = await req.json();
  if (body.status !== "OK") throw new Error(body);
  return body;
};
